import './Button.scss';
import React from 'react';
import { Loader } from 'rsuite';

export default function Button ({ className = '', type, form, loading = false, disabled, block = false, children, onClick } = {}) {
    return (
        <button
            className={`ctech-button ${className}`}
            type={type}
            form={form}
            disabled={disabled}
            loading={loading.toString()}
            block={block.toString()}
            onClick={onClick}
        >
            {loading && <Loader inverse className="ctech-button-loader" />}
            <span className="ctech-button-content">{children}</span>
        </button>
    );
}
